"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var components_1 = require("@/components");
var InputField = function (props, ref) {
    return (0, jsx_runtime_1.jsx)(components_1.ToggleButton, __assign({ ref: ref }, props), void 0);
};
exports.default = (0, react_2.forwardRef)(InputField);
